//Sarada : 10-10-2022
import { FAQs_GET_LIST } from "../../../redux/contants";

// eslint-disable-next-line import/prefer-default-export
export const getfaqs = (data) => ({
    type: FAQs_GET_LIST,
    payload: data
});